import React, { useState } from "react";
import { Container, Grid } from "@mui/material";

import Menu from '../../Components/Menu/MainMenu'
import page404 from './page404.png'

const OtherResponse = () => {
  const [useMessage, setMessage] = useState('Some thing went wrong');
  var urlResponse = window.location.search.split('d=')[1]
  switch (urlResponse) {
    case 'already-verified':
      return (
        <div 
        className="MS---Header">
          <Menu />
          <Container maxWidth="lg">
          <Grid
              container
              direction="row"
              justifyContent="center"
              alignItems="center"
              className="py-5"
          >
              <Grid
                  xs={12}
                  className="text-center"
              >
                <h3 className="text-light">already-verified</h3>
                <img src={page404} style={{width: '100%', maxWidth: 500, height: 'auto'}} />
              </Grid>
          </Grid>
          </Container>
        </div>
      );
      break; 
    case 'token-not-found-or-token-expired':
      return (
        <div 
        className="MS---Header">
          <Menu />
          <Container maxWidth="lg">
          <Grid
              container
              direction="row"
              justifyContent="center"
              alignItems="center"
              className="py-5"
          >
              <Grid
                  xs={12}
                  className="text-center"
              >
                <h3 className="text-light">token-not-found-or-token-expired</h3>
                <img src={page404} style={{width: '100%', maxWidth: 500, height: 'auto'}} />
              </Grid>
          </Grid>
          </Container>
        </div>
      );
    break; 
    case 'invalid-token':
      return (
        <div 
        className="MS---Header">
          <Menu />
          <Container maxWidth="lg">
          <Grid
              container
              direction="row"
              justifyContent="center"
              alignItems="center"
              className="py-5"
          >
              <Grid
                  xs={12}
                  className="text-center"
              >
                <h3 className="text-light">invalid-token</h3>
                <img src={page404} style={{width: '100%', maxWidth: 500, height: 'auto'}} />
              </Grid>
          </Grid>
          </Container>
        </div>
      );
    break; 
    default:
      return (
        <div 
        className="MS---Header">
          <Menu />
          <Container maxWidth="lg">
          <Grid
              container
              direction="row"
              justifyContent="center"
              alignItems="center"
              className="py-5"
          >
              <Grid
                  xs={12}
                  className="text-center"
              >
                <h3 className="text-light">Some thing went wrong</h3>
                <img src={page404} style={{width: '100%', maxWidth: 500, height: 'auto'}} />
              </Grid>
          </Grid>
          </Container>
        </div>
      );
      break;
  }
}

export default OtherResponse;
